/**
 * Lista de clientes do CRM (redesign admin, Fase 4). Puro e sem I/O: filtro de
 * apresentação sobre `CrmDataset.customers` (a visão 360 continua em
 * `/clientes/:customerId`).
 */
import type { CrmCustomer } from "../api/types.js";

function fold(text: string): string {
  return text.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();
}

export interface CustomerFilters {
  query: string;
  /** `null` = todas as origens. */
  origin: string | null;
}

export function filterCustomers(customers: CrmCustomer[], filters: CustomerFilters): CrmCustomer[] {
  const query = fold(filters.query);
  const digits = filters.query.replace(/\D/g, "");
  return customers.filter((customer) => {
    if (filters.origin && customer.origin !== filters.origin) return false;
    if (!query) return true;
    if (fold(customer.name).includes(query) || fold(customer.email ?? "").includes(query)) return true;
    // Telefone: compara só dígitos (o cadastro pode vir formatado).
    return digits.length >= 3 && (customer.phone ?? "").replace(/\D/g, "").includes(digits);
  });
}

export function customerOrigins(customers: CrmCustomer[]): string[] {
  return [...new Set(customers.map((customer) => customer.origin))].sort();
}
